import { List } from 'immutable';

// Note, order here determines order on daily news top page.
export const DAILY_NEWS_CATEGORY_TAGS = List([
  'Science & Technology',
  'Culture & Entertainment',
  'Economy & Business',
  'Health',
  'Language & Education',
  'Asia & Pacific',
  'USA & Americas',
  'Europe',
  'Middle East & Africa',
]);
